module.exports = __webpack_public_path__ + "img/maopi.prt.0f726622.jpg";